jQuery(($) => {
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Browser - Keydown Focus Class
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $("body").on("keydown", function () {
    if (!$(".keyboard-in-use")[0]) {
      $(this).addClass("keyboard-in-use");
    }
  });

  $("body").on("mousedown", function () {
    if ($(".keyboard-in-use")[0]) {
      $(this).removeClass("keyboard-in-use");
    } 
  });

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Browser: Animate Scroll to Anchor Link
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').not('[href="#content"]').click(function (e) {
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        let target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

        if (target.length) {
          e.preventDefault();

          const targetTop = target.offset().top - 200;

          $('html, body').animate({
            scrollTop: targetTop > 0 ? targetTop : 0
          }, 600);
        }
      }
    });

});
